module.exports = __webpack_public_path__ + "static/media/logo.f5e74cd2.svg";